module.exports = __webpack_public_path__ + "img/cb_icon.5efc04b1.png";